export default "__VITE_ASSET__jp0aE2iX__"